import { createAction, props } from '@ngrx/store';

import { EstablishmentType, HotelConfigModel, HotelModel, RoomModel } from '../../models';

export const loadHotelByUser = createAction('[Hotel/API] Load Hotel by user', props<{ userUid: string }>());
export const loadHotel = createAction('[Hotel/API] Load Hotel', props<{ hotelUid: string }>());

export const setHotel = createAction('[Hotel/API] Set Hotel', props<{ hotel: HotelModel }>());

export const loadHotelConfig = createAction('[Hotel/API] Load Hotel Config', props<{ hotelUid: string }>());

export const setHotelConfig = createAction('[Hotel/API] Set Hotel Config', props<{ hotelConfig: HotelConfigModel }>());

export const setHotelRooms = createAction('[Hotel/API] Set Hotel Rooms', props<{ rooms: RoomModel[] }>());

export const setEstablishmentType = createAction(
  '[Hotel/API] Set Establishment Type',
  props<{ establishmentType: EstablishmentType | null }>(),
);

export const updateHotelConfig = createAction(
  '[Hotel/API] Update Hotel Config',
  props<{ hotelUid: string; config: Partial<HotelConfigModel> }>(),
);

export const updateHotelConfigSuccess = createAction('[Hotel/API] Update Hotel Config Success');
